export default __webpack_public_path__ + "static/media/header-background.5432850e.webp";